<template>
  <div>
    <b-table
      striped
      responsive
      hover
      :items="items"
      :fields="fields"
      :busy="isBusy"
      show-empty
      :empty-text="$t('noData')"
    >
      <template v-slot:table-busy>
        <div class="text-center text-black my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="ml-2">Loading...</strong>
        </div>
      </template>
      <template #cell(show_details)="row">
        <b-button size="sm" @click="toggleRow(row, row.item)" class="mr-2">
          {{ row.detailsShowing ? "-" : "+" }}
        </b-button>
      </template>

      <template #row-details="row">
        <div class="d-none">{{ row.item.reasonId }}</div>
        <div v-if="row.item.items === undefined">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="ml-2">Loading...</strong>
        </div>
        <div v-if="row.item.items !== undefined">
          <b-table
            striped
            responsive
            hover
            :items="row.item.items"
            :fields="orderItemfields"
            show-empty
            :empty-text="$t('noData')"
          >
            <template v-slot:cell(productPrice)="data">
              <div class="d-flex justify-content-center">
                ฿ {{ data.item.grandTotal | numeral("0,0.00") }}
              </div>
            </template>
            <template v-slot:cell(grandTotal)="data">
              <div class="d-flex justify-content-center">
                ฿ {{ data.item.grandTotal | numeral("0,0.00") }}
              </div>
            </template>
            <template v-slot:cell(discount)="data">
              <div class="d-flex justify-content-center">
                ฿ {{ data.item.grandTotal | numeral("0,0.00") }}
              </div>
            </template></b-table
          >
        </div>
        <div class="pl-3">
          <div class="text-left">
            ค่าธรรมเนียมขนส่ง: ฿ {{ row.item.shippingCost | numeral("0,0.00") }}
          </div>
          <div class="text-left">
            ยอดสุทธิ: ฿ {{ row.item.grandTotal | numeral("0,0.00") }}
          </div>
        </div>
      </template>
      <template v-slot:cell(createdTime)="data">
        <div class="d-flex justify-content-center">
          {{ new Date(data.item.createdTime) | moment($formatDateTime) }}
        </div>
      </template>
      <template v-slot:cell(detail)="data">
        <div class="d-flex justify-content-center">
          <div>{{ data.item.firstname }} {{ data.item.lastname }}</div>
          <div>{{ data.item.telephone }}</div>
          <div>
            {{ data.item.shippingAddress.address }}
            {{ data.item.shippingAddress.road }}
            {{ data.item.shippingAddress.district }}
            {{ data.item.shippingAddress.subDistrict }}
            {{ data.item.shippingAddress.province }}
            {{ data.item.shippingAddress.zipcode }}
          </div>
        </div>
      </template>
      <template v-slot:cell(grandTotal)="data">
        <div class="d-flex justify-content-center">
          ฿ {{ data.item.grandTotal | numeral("0,0.00") }}
        </div>
      </template>
    </b-table>
    <b-pagination
      v-model="filter.paging.pageNo"
      :total-rows="filter.paging.total"
      :per-page="filter.paging.perPage"
      class="m-md-0"
      @change="onPageChange"
      align="right"
    ></b-pagination>
  </div>
</template>

<script>
export default {
  props: {
    liveId: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      items: null,
      filter: {
        livePostId: 0,
        paging: {
          pageNo: 1,
          perPage: 10,
          total: 0,
        },
      },
      fields: [
        {
          key: "show_details",
          label: "Show Details",
          class: "w-100px",
        },
        {
          key: "createdTime",
          label: "วันที่ และ เวลา",
          class: "w-100px",
        },
        {
          key: "invoiceNo",
          label: "เลขที่คำสั่งซื้อ",
          class: "w-100px",
        },
        {
          key: "detail",
          label: "รายละเอียด",
          class: "w-100px",
        },
        {
          key: "orderQuantity",
          label: "จำนวนสินคัา",
          class: "w-100px",
        },
        {
          key: "paymentTypeName",
          label: "ช่องทางการชำระเงิน",
          class: "w-160px",
        },
        {
          key: "shippingTypeName",
          label: "ขนส่งที่เลือก",
          class: "w-100px",
        },
        {
          key: "grandTotal",
          label: "ยอดเงินที่ชำระ",
          class: "w-100px",
        },
        {
          key: "orderStatusName",
          label: "สถานะ",
        },
      ],
      orderItemfields: [
        {
          key: "keyword",
          label: "Keyword",
        },
        {
          key: "productName",
          label: "Product Details",
        },
        {
          key: "sku",
          label: "SKU",
        },
        {
          key: "orderItemQuantity",
          label: "QTY",
        },
        {
          key: "productPrice",
          label: "Price",
        },
        {
          key: "grandTotal",
          label: "Total",
        },
        {
          key: "discount",
          label: "Discount",
        },
      ],
      isBusy: false,
    };
  },
  created() {
    this.filter.livePostId = this.liveId;
    this.getOrders();
  },
  methods: {
    async getOrders() {
      this.isBusy = true;
      await this.axios
        .post(`${this.$baseUrl}/livepost/orderpost/list`, this.filter)
        .then((data) => {
          console.log("get orders resposne", data);
          if (data.result == 1) {
            this.items = data.detail.dataList;
            this.filter.total = data.detail.count;
          }
        });
      this.isBusy = false;
    },
    onPageChange(page) {
      this.filter.paging.pageNo = page;
      this.getOrders();
    },
    async getOrderItems(order) {
      await this.axios
        .get(`${this.$baseUrl}/livepost/orderItem/${order.id}`)
        .then((data) => {
          console.log("get orders item response", data);
          if (data.result == 1) {
            order.items = data.detail;
            order.reasonId = 1;
          }
        });
    },
    toggleRow(row, order) {
      row.toggleDetails();
      if (order.items === undefined) {
        this.getOrderItems(order);
      }
    },
  },
};
</script>

<style></style>
